// extracted by mini-css-extract-plugin
export default {"root":"_3jkpi","scrollable":"_2Pesc","size-small":"_1BzlL","sizeSmall":"_1BzlL","size-medium":"_2-cqb","sizeMedium":"_2-cqb","tag-item":"_3S2Vf","tagItem":"_3S2Vf"};